import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useAuthStore } from '../stores/authStore';
import { landingPathFor } from '../routes/navigation';

export function NotFoundPage() {
  const { t } = useI18n();
  const status = useAuthStore((state) => state.status);
  const permissions = useAuthStore((state) => state.permissions);

  useDocumentTitle(t.errors.notFoundTitle);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page px-4">
      <div className="card w-full max-w-md p-7 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-surface-sunken text-ink-muted">
          <FileQuestion className="h-7 w-7" aria-hidden="true" />
        </div>

        <h1 className="text-lg font-semibold text-ink">{t.errors.notFoundTitle}</h1>
        <p className="mt-2 text-sm text-ink-muted">{t.errors.notFoundBody}</p>

        <Link
          to={status === 'authenticated' ? landingPathFor(permissions) : '/login'}
          className="btn-primary mt-6 w-full"
        >
          {status === 'authenticated' ? t.errors.goToStart : t.errors.signInAgain}
        </Link>
      </div>
    </div>
  );
}
